import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Products = () => {
  const [products] = useState([
    { name: 'Mobile Application', price: 'Rs. 15000', description: 'User-friendly mobile application development', rating: 4.8 },
    { name: 'POS System', price: 'Rs. 50000', description: 'Reliable point-of-sale system', rating: 4.5 },
    { name: 'Website Development', price: 'Rs. 30000', description: 'Custom website design and development', rating: 4.7 },
    { name: 'Streaming Application', price: 'Rs. 20000', description: 'High-performance streaming app development', rating: 4.6 },
    { name: 'Chatting Application', price: 'Rs. 25000', description: 'Secure and scalable chatting app', rating: 4.9 },
  ]);

  const [reviews] = useState([
    { name: 'Kasun Perera', review: 'Amazing product! Highly recommended.', rating: 5 },
    { name: 'Nimali Fernando', review: 'Good quality, worth the price.', rating: 4 },
    { name: 'Sajith Silva', review: 'Satisfying experience, fast delivery!', rating: 5 },
    { name: 'Ruwan De Silva', review: 'Not bad, but could be better.', rating: 3.5 },
  ]);

  const navigate = useNavigate(); // Initialize useNavigate for navigation

  // Animate the elements after page load
  useEffect(() => {
    const elements = document.querySelectorAll('.product-card, .review');
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('animate-fade-in');
      }, index * 300); // Delay for each element
    });
  }, []);

  // Handle the navigation to the dashboard
  const handleNavigateToDashboard = () => {
    navigate('/dashboard'); // Navigate to dashboard page
  };

  return (
    <div style={styles.container}>
      {/* Home Button */}
      <button onClick={handleNavigateToDashboard} style={styles.homeButton}>
        Home
      </button>

      <h2 style={styles.title}>Our Products</h2>
      <div style={styles.productGrid}>
        {products.map((product, index) => (
          <div key={index} className="product-card" style={styles.productCard}>
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <p><strong>{product.price}</strong></p>
            <p>Rating: {product.rating} ⭐</p>
          </div>
        ))}
      </div>

      <h2 style={styles.reviewTitle}>Customer Reviews</h2>
      <div style={styles.reviewGrid}>
        {reviews.map((review, index) => (
          <div key={index} className="review" style={styles.reviewCard}>
            <p><strong>{review.name}</strong></p>
            <p>{review.review}</p>
            <p>Rating: {review.rating} ⭐</p>
          </div>
        ))}
      </div>

      {/* Inline styles for animations */}
      <style>
        {`
          .product-card, .review {
            opacity: 0;
            transform: translateY(50px);
            transition: opacity 0.5s ease, transform 0.5s ease;
          }

          .animate-fade-in {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }

          .product-card:hover, .review:hover {
            transform: scale(1.05);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
          }

          @keyframes fade-in {
            0% {
              opacity: 0;
              transform: translateY(-30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'black',
    color: '#00FFFF',
    padding: '20px',
    textAlign: 'center',
    minHeight: '100vh',
  },
  homeButton: {
    backgroundColor: '#00FFFF',
    color: 'black',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '20px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    position: 'absolute',
    top: '20px',
    left: '20px',
  },
  title: {
    fontSize: '2.5rem',
    marginBottom: '30px',
    animation: 'fade-in 1s ease-in-out',
  },
  productGrid: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },
  productCard: {
    backgroundColor: 'white',
    color: 'black',
    padding: '20px',
    borderRadius: '10px',
    width: '250px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  reviewTitle: {
    fontSize: '2rem',
    marginTop: '40px',
    marginBottom: '20px',
  },
  reviewGrid: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '15px',
  },
  reviewCard: {
    backgroundColor: 'white',
    color: 'black',
    padding: '15px',
    borderRadius: '10px',
    width: '300px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
};

export default Products;
